"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.days = exports.Yesterday = exports.classes = void 0;
var classes = {
  notificationCard: 'bds-notification-card',
  cardContent: 'bds-card-content',
  cardHeader: 'bds-card-header',
  cardTitle: 'bds-card-title',
  cardTime: 'bds-card-time',
  cardMessage: 'bds-card-message',
  cardActionFooter: 'bds-card-action-footer',
  secondaryButtonSpacing: 'secondary-button-spacing',
  notificationCardWithSpinnerOverlay: 'bds-notification-card-with-spinner-overlay'
};
exports.classes = classes;
var Yesterday = 'Yesterday';
exports.Yesterday = Yesterday;
var days = 'days';
exports.days = days;